// @flow
import React from 'react';
import type { ProductItem } from 'store/modules/display';
import './UserProductCardList.scss';
import UserProductCard from '../UserProductCard';

type Props = {
  products: ProductItem[],
  username: string,
};

const UserProductCardList = ({ products, username }: Props) => {
  const productList = products.map(product => (
    <UserProductCard username={username} key={product.id} product={product} />
  ));
  return (
    <div className="UserProductCardList">
      {products && products.length === 0 && <div className="no-products">상품이 없습니다.</div>}
      {productList}
    </div>
  );
};

UserProductCardList.Placeholder = () => {
  return (
    <div className="UserProductCardList">
      <UserProductCard.Placeholder />
      <UserProductCard.Placeholder />
      <UserProductCard.Placeholder />
    </div>
  );
};

export default UserProductCardList;



// WEBPACK FOOTER //
// ./src/components/user/UserProductCardList/UserProductCardList.js